import { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Container, Button, Box, Stack, Typography, TextField, Tooltip, Alert, AlertTitle, Avatar, Input, IconButton, Badge, CardActions, Divider, Card, CardContent, Dialog } from '@mui/material';
import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel } from '@mui/material';

import copy from "copy-text-to-clipboard";

import Webcam from "react-webcam";

import { toTitleCase, urlToFile } from '../utilities/common';

import { pb } from '../utilities/pocketbase';

import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded';
import AddPhotoAlternateIcon from '@mui/icons-material/AddPhotoAlternate';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import AddAPhotoRoundedIcon from '@mui/icons-material/AddAPhotoRounded';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

export default function FinalistProfileUpdate() {
    const [oldProfileData, setOldProfileData] = useState({})
    const [photo, setPhoto] = useState()
    const [schoolId, setSchoolId] = useState()
    const [profile, setProfile] = useState({
        fullname: "",
        guardian_fullname: "",
        guardian_address: "",
        guardian_mobile: "",
        guardian_email: "",
        school_name: "",
        school_address: "",
        gender: ""
    })
    const [refresh, setRefresh] = useState(false)
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState("")
    const [isFinalist, setIsFinalist] = useState(false)
    const [finalistProfile, setFinalistProfile] = useState()
    const [isNewProfileComplete, setIsNewProfileComplete] = useState(false)
    const [finalistCredentials, setFinalistCredentials] = useState()
    const [sendRequest, setSendRequest] = useState(false)

    const navigate = useNavigate();

    useEffect(() => {
        if (pb?.authStore?.model?.id && pb?.authStore?.model?.collectionName === 'examinees') {
            setLoading(true)
            console.log(pb?.authStore?.model?.id)
            pb.collection('finalist_examinee_ids').getOne(pb?.authStore?.model?.id).then(finalistId => {
                console.log("✅ finalist ✅", finalistId)
                setIsFinalist(true)
                setLoading(false)
                pb.collection('examinees').getOne(pb?.authStore?.model?.id, { expand: "profile, exam" }).then(examinee => {
                    console.log("examinee:", examinee)
                    setOldProfileData(examinee)
                }).catch(err => {
                    setError(err)
                })
                pb.collection('finalist_profiles').getFirstListItem(`examinee = "${pb?.authStore?.model?.id}"`).then(record => {
                    console.log("finalist profile:", record)
                    if (record) {
                        setIsNewProfileComplete(true)
                        setFinalistProfile(record)
                    }
                }).catch(err => {
                    setIsNewProfileComplete(false)
                })
                pb.collection('finalist_creds').getFirstListItem(`examinee = "${pb?.authStore?.model?.id}"`).then(record => {
                    if (record) {
                        setFinalistCredentials(record)
                    }
                }).catch(err => {
                    console.log(err)
                })
            }).catch(err => {
                console.log("❌ not a finalist! ❌", err)
                setIsFinalist(false)
                setLoading(false)
                setError(err?.message)
            })

        }
    }, [refresh])

    useEffect(() => {
        if (sendRequest && finalistCredentials?.username && finalistCredentials?.password) {
            setError("")
            pb.collection(`finalists`).authWithPassword(finalistCredentials?.username, finalistCredentials?.password).then(record => {
                // console.log("login record:", record)
                // console.log(pb.authStore.isValid);
                // console.log(pb.authStore.token);
                console.log(pb.authStore.model.id);
                navigate('/')
            }).catch(error => {
                console.log("login error:", error)
                setError(error?.message)
            }).finally(() => setSendRequest(false))
        }
    }, [sendRequest, finalistCredentials?.username, finalistCredentials?.password, navigate])

    const submitProfile = () => {
        const data = new FormData()
        for (const key of Object.keys(profile)) {
            data.append(key, profile[key])
        }
        photo && data.append("display_picture", photo)
        schoolId && data.append("school_id_card", schoolId)
        data.append("examinee", pb?.authStore?.model?.id)

        pb.collection('finalist_profiles').create(data).then(record => {
            console.log("success:", record)
            setError("")
            setRefresh(ps => !ps)
        }).catch(err => {
            setError(err)
        })
    }

    return (
        <Container maxWidth="md" sx={{ py: 2 }}>
            <Stack justifyContent={"center"} alignItems={"center"} spacing={2}>
                <Button sx={{ px: 2, py: 1, borderRadius: 12, m: 2, border: 2 }} startIcon={<ArrowBackRoundedIcon />} component={Link} to={"/"}>Go Back</Button>
                {isNewProfileComplete ? <Alert sx={{ justifyContent: "center", borderRadius: 3 }}>
                    <AlertTitle>
                        Profile update status
                    </AlertTitle>
                    Profile update for final exam is already completed!
                </Alert> : <Alert severity='warning' sx={{ justifyContent: "center", borderRadius: 3 }}>
                    <AlertTitle>
                        Profile update status
                    </AlertTitle>
                    Profile update for final exam is not completed, Please complete to attend the final exam. Make sure to enter details correctly.
                </Alert>}

                {finalistCredentials && finalistCredentials?.username && finalistCredentials?.password && <Button variant='contained' color='success' onClick={() => setSendRequest(true)} endIcon={<ArrowForwardIcon />} sx={{ textTransform: "none", p: 2, mt: 2 }} fullWidth>Login as finalist</Button>}
                {/* {finalistCredentials && finalistCredentials?.username && finalistCredentials?.password && <Alert severity='info' icon={false} sx={{ justifyContent: "center", borderRadius: 3, border: 2 }}>
                    <AlertTitle>
                        Your Finalist Credentials
                    </AlertTitle>

                    <Stack spacing={1}>
                        <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                            <Typography variant='h6' fontFamily={"JetBrains Mono"}>
                                Username: {finalistCredentials?.username}
                            </Typography>
                            <Tooltip placement='right' arrow title={"Copy to clipboard"}>
                                <IconButton onClick={() => copy(finalistCredentials?.username)}><ContentCopyIcon fontSize='small' /></IconButton>
                            </Tooltip>
                        </Stack>

                        <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                            <Typography variant='h6' fontFamily={"JetBrains Mono"}>
                                Password: {finalistCredentials?.password}
                            </Typography>
                            <Tooltip placement='right' arrow title={"Copy to clipboard"}>
                                <IconButton onClick={() => copy(finalistCredentials?.password)}><ContentCopyIcon fontSize='small' /></IconButton>
                            </Tooltip>
                        </Stack>

                        <Button variant='contained' onClick={() => setSendRequest(true)} endIcon={<ArrowForwardIcon />} sx={{ textTransform: "none", p: 1 }} fullWidth>Login as finalist</Button>
                    </Stack>
                </Alert>} */}
            </Stack>

            <Stack spacing={2} sx={{ border: 2, borderRadius: 3, borderColor: "divider", p: 2, my: 2, boxShadow: 3 }}>
                <Typography variant='subtitle1' fontWeight={"bold"}>Examinee Profile</Typography>
                {oldProfileData?.expand?.profile && <Stack justifyContent={"center"} alignItems={"center"}>
                    <Box sx={{ py: 1 }}>
                        <Avatar sx={{ height: "8rem", width: "8rem" }} alt={oldProfileData?.firstname?.split()[0]} src={`${process.env.REACT_APP_PB_URL}/api/files/${oldProfileData?.expand?.profile?.collectionId}/${oldProfileData?.expand?.profile?.id}/${oldProfileData?.expand?.profile?.avatar}`} />
                    </Box>
                </Stack>}
                <Stack>
                    <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant='subtitle2' color={"text.secondary"}>First name</Typography>
                        <Typography variant='subtitle1'>{oldProfileData?.expand?.profile?.firstname}</Typography>
                    </Stack>
                    <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant='subtitle2' color={"text.secondary"}>Last name</Typography>
                        <Typography variant='subtitle1'>{oldProfileData?.expand?.profile?.lastname}</Typography>
                    </Stack>
                    <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant='subtitle2' color={"text.secondary"}>Year of Birth</Typography>
                        <Typography variant='subtitle1'>{oldProfileData?.expand?.profile?.yob}</Typography>
                    </Stack>
                    <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant='subtitle2' color={"text.secondary"}>Mobile</Typography>
                        <Typography variant='subtitle1'>{oldProfileData?.expand?.profile?.mobile}</Typography>
                    </Stack>
                    <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant='subtitle2' color={"text.secondary"}>Email</Typography>
                        <Typography variant='subtitle1'>{oldProfileData?.expand?.profile?.email}</Typography>
                    </Stack>
                    <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant='subtitle2' color={"text.secondary"}>Class</Typography>
                        <Typography variant='subtitle1'>{oldProfileData?.expand?.profile?.class}</Typography>
                    </Stack>
                    <Stack direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                        <Typography variant='subtitle2' color={"text.secondary"}>Preliminary exam attended</Typography>
                        <Typography variant='subtitle1'>{oldProfileData?.expand?.exam?.name}</Typography>
                    </Stack>
                </Stack>
                {isNewProfileComplete && finalistProfile && <Stack spacing={2}>
                    <Divider />
                    <Typography variant='subtitle1' fontWeight={"bold"}>Finalist Information</Typography>
                    {oldProfileData?.expand?.profile && <Stack justifyContent={"center"} alignItems={"center"}>
                        <Box sx={{ py: 1 }}>
                            <Avatar sx={{ height: "8rem", width: "8rem" }} alt={finalistProfile?.fullname?.split()[0]} src={`${process.env.REACT_APP_PB_URL}/api/files/${finalistProfile?.collectionId}/${finalistProfile?.id}/${finalistProfile?.display_picture}`} />
                        </Box>
                    </Stack>}
                    <Stack>
                        {Object.keys(finalistProfile).filter(key => !["display_picture", "school_id_card", "collectionId", "collectionName", "created", "updated", "id"].includes(key)).map(key => (
                            <Stack key={key} direction={"row"} spacing={2} justifyContent={"space-between"} alignItems={"center"}>
                                <Typography variant='subtitle2' color={"text.secondary"}>{toTitleCase(key)}</Typography>
                                <Typography variant='subtitle1'>{finalistProfile?.[key]}</Typography>
                            </Stack>
                        ))}
                    </Stack>
                </Stack>}
            </Stack>
            {!isNewProfileComplete && <Card variant='outlined' sx={{ borderRadius: 3 }}>
                <Alert severity='info' sx={{ justifyContent: "center" }}>Make sure to upload clear face photo</Alert>
                <CardContent>
                    <Stack spacing={2}>
                        <Stack justifyContent={"center"} alignItems={"center"}>
                            <Box sx={{ py: 1 }}>
                                <Badge
                                    overlap="circular"
                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                    badgeContent={<UploadImage id={"finalist_dp"} setPhoto={setPhoto} />}
                                >
                                    <Avatar sx={{ height: "8rem", width: "8rem", ...(error?.data?.data?.display_picture && { border: 2, borderColor: "red" }) }} alt={"❌"} src={photo ? URL.createObjectURL(photo) : ""} />
                                </Badge>
                            </Box>
                            <TakePicture setPicture={setPhoto} />
                            {error?.data?.data?.display_picture && <Typography variant='caption' color={"error"}>{error?.data?.data?.display_picture?.message}</Typography>}
                        </Stack>

                        <TextField required fullWidth value={profile.firstname} onChange={(e) => setProfile(ps => ({ ...ps, fullname: e.target.value }))} label={"fullname"} error={error?.data?.data?.fullname} helperText={error?.data?.data?.fullname?.message} />

                        <FormControl sx={{ pl: 1 }}>
                            <FormLabel>Gender *</FormLabel>
                            <RadioGroup
                                row
                                value={profile?.gender}
                                onChange={(e) => setProfile(ps => ({ ...ps, gender: e.target.value }))}
                            >
                                <FormControlLabel value="male" control={<Radio />} label="Male" />
                                <FormControlLabel value="female" control={<Radio />} label="Female" />
                            </RadioGroup>
                            {error?.data?.data?.gender && <Typography variant='caption' color={"error"}>{error?.data?.data?.gender?.message}</Typography>}
                        </FormControl>

                        <TextField required fullWidth value={profile.guardian_fullname} onChange={(e) => setProfile(ps => ({ ...ps, guardian_fullname: e.target.value }))} label={"guardian's fullname"} error={error?.data?.data?.guardian_fullname} helperText={error?.data?.data?.guardian_fullname?.message} />

                        <TextField required fullWidth value={profile.guardian_address} onChange={(e) => setProfile(ps => ({ ...ps, guardian_address: e.target.value }))} label={"guardian's address"} error={error?.data?.data?.guardian_address} helperText={error?.data?.data?.guardian_address?.message} />

                        <TextField required fullWidth value={profile.guardian_mobile} onChange={(e) => setProfile(ps => ({ ...ps, guardian_mobile: e.target.value }))} label={"guardian's mobile"} error={error?.data?.data?.guardian_mobile} helperText={error?.data?.data?.guardian_mobile?.message} />

                        <TextField required fullWidth value={profile.guardian_email} onChange={(e) => setProfile(ps => ({ ...ps, guardian_email: e.target.value }))} label={"guardian's email"} error={error?.data?.data?.guardian_email} helperText={error?.data?.data?.guardian_email?.message} />

                        <TextField required fullWidth value={profile.school_name} onChange={(e) => setProfile(ps => ({ ...ps, school_name: e.target.value }))} label={"school name"} error={error?.data?.data?.school_name} helperText={error?.data?.data?.school_name?.message} />

                        <TextField required fullWidth value={profile.school_address} onChange={(e) => setProfile(ps => ({ ...ps, school_address: e.target.value }))} label={"school address"} error={error?.data?.data?.school_address} helperText={error?.data?.data?.school_address?.message} />

                        <Stack>
                            <Box sx={{ border: 1, borderRadius: 1, p: 1, px: 2, borderColor: error?.data?.data?.school_id_card ? "red" : "gray" }}>
                                <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                                    {schoolId ? <Typography variant='body1'>{`${schoolId?.name} • ${schoolId?.size} bytes`}</Typography> : <Typography color={"text.secondary"} variant='body1'>School id card *</Typography>}
                                    <Box sx={{ flexGrow: 1 }}></Box>
                                    <UploadFile id={"school_id_card"} setFile={setSchoolId} />
                                </Stack>
                            </Box>
                            <Typography variant='caption' color={"error"}>{error?.data?.data?.school_id_card?.message}</Typography>
                        </Stack>

                        <CardActions sx={{ px: 0 }}>
                            <Button sx={{ p: 2 }} startIcon={<ArrowBackRoundedIcon />} component={Link} to={"/"} fullWidth>Back</Button>
                            <Button sx={{ p: 2 }} endIcon={<ArrowForwardIcon />} onClick={submitProfile} variant='contained' fullWidth>Submit</Button>
                        </CardActions>
                    </Stack>
                </CardContent>
            </Card>}
        </Container >
    )
}

function TakePicture({ setPicture }) {
    const [open, setOpen] = useState(false)
    const [mediaDevices, setMediaDevices] = useState([])
    const videoConstraints = {
        width: 1280,
        height: 720,
        facingMode: "user"
    };

    useEffect(() => {
        navigator.mediaDevices.enumerateDevices().then(mediaDeviceList => {
            setMediaDevices(mediaDeviceList.filter(({ kind }) => kind === "videoinput"))
        })
    }, [])

    return (
        <Stack>
            <Tooltip title="Take a photo">
                <IconButton color='success' onClick={() => setOpen(true)} >
                    <AddAPhotoRoundedIcon />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={() => setOpen(false)} PaperProps={{ sx: { borderRadius: 3 } }}>
                <Card variant="outlined" sx={{ borderRadius: 3 }}>
                    <Stack justifyContent={"center"}>
                        <Webcam
                            mirrored
                            audio={false}
                            height={200}
                            screenshotFormat="image/png"
                            // width={1280}
                            videoConstraints={videoConstraints}
                        >
                            {({ getScreenshot }) => (
                                <Button
                                    sx={{ p: 2, py: 2 }}
                                    onClick={() => {
                                        const imageSrc = getScreenshot()
                                        urlToFile(imageSrc).then(pic => setPicture(pic)).catch(err => console.log(err))
                                        setOpen(false)
                                    }}
                                >
                                    Capture photo
                                </Button>
                            )}
                        </Webcam>
                        {mediaDevices.length === 0 && <Alert severity="error" sx={{ justifyContent: "center", py: 2 }}>
                            <AlertTitle>
                                No Camera Found!
                            </AlertTitle>
                            You need to have camera support on the system to attend this exam.
                        </Alert>}
                    </Stack>
                </Card>
            </Dialog>
        </Stack>
    )
}

function UploadImage({ id, setPhoto }) {
    const handelPhotoUpload = (e) => {
        var file = e.target.files[0];
        setPhoto(file)
    }

    return (
        <label htmlFor={id}>
            <Input id={id} accept='image/png, image/jpeg, image/bmp, image.gif, image/jpg' type="file" onChange={handelPhotoUpload}
                style={{ width: '0px', visibility: 'hidden' }} />
            <Tooltip title="Upload photo" placement="bottom"><IconButton color="warning" component="span">
                <AddPhotoAlternateIcon />
            </IconButton></Tooltip>
        </label>
    )
}

function UploadFile({ id, setFile }) {
    const handelFileUpload = (e) => {
        var file = e.target.files[0];
        setFile(file)
    }

    return (
        <label htmlFor={id}>
            <Input id={id} accept='image/png, image/jpeg, image/bmp, application/pdf, image/jpg' type="file" onChange={handelFileUpload}
                style={{ width: '0px', visibility: 'hidden' }} />
            <Tooltip title="Upload file" placement="bottom"><IconButton color="warning" component="span">
                <UploadFileIcon />
            </IconButton></Tooltip>
        </label>
    )
}